module.exports = __webpack_public_path__ + "media/smiles/liked_1-4461d246.svg";